module.exports = __webpack_public_path__ + "760be2b12ac7529e591773f195bde07e.png";